import React,{ useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import {Button,Card,Form,Container,Row,Col} 
from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import DataTable from "react-data-table-component";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit,faDeleteLeft} from "@fortawesome/free-solid-svg-icons";
import "assets/css/grid.css";
import { useFichaConsultante } from 'hooks/useFichaConsultante';
import {MensajeAlerta} from '../Messages/MensajeAlerta';
import Select from 'react-select'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from 'moment';
import 'moment/locale/es';

const paginacionOpciones={
    rowsPerPageText:'Número elementos',
    rangeSeparatorText:'de',
    selectAllRowsItemsText:'Todos'
}
function ListadoParticipacionesGrupalesFicha(){
    const parametros = useParams();
    const { participacionGrupalFicha, 
        getParticipacionGrupalPorConsultante,
        getUsuariosTerapeutasOcupacionales,
        getUsuariosPsicologas,
        getUsuariosOtros,
        usuariosTo,
        usuariosSicologas,
        usuariosOtros,
        insertParticipacionGrupal,
        respuestaIngresoParticipacionGrupal,
        updateRespuestaIngresoParticipacionGrupal,
        deleteFichaConsultanteParticipacionGrupal
    
        } = useFichaConsultante({Id:parametros.id});
        
        const [isChangedElements,setChange]=useState(false);
        let opcionesSelectorTO=[];
        let opcionesSelectorPsicologas=[];
        let opcionesSelectorOtros=[];
        const [ participacionGrupalPorIngresar, setParticipacionGrupalPorIngresar] = useState({});
   
    const columnas=[
    {
        name:'Id',
        selector: row => row.Id,
        sorteable:true,
        omit:true
    },
    {
        name:'Fecha Sesión',
        selector: row => moment.utc(row.FechaSesion).format('DD/MM/YYYY HH:mm:ss'),
        sorteable:true,
        render: function (data, type, row, meta) {
            
            return moment.utc(data).local().format('DD/MM/YYYY HH:mm:ss');
        }
    },
    {
        name:'Comentarios',
        selector: row => row.Comentario,
        sorteable:true
    },
    {
        cell: row => (
            <>
            <a href={'../EditarParticipacionGrupal/'+row.Id} rel="noopener noreferrer">
            	<FontAwesomeIcon icon={faEdit} />
            </a>
            &nbsp;&nbsp;&nbsp;
            <a href="#" onClick={event=>onDelete(row.Id)} rel="noopener noreferrer" title='Eliminar'>
            	<FontAwesomeIcon icon={faDeleteLeft} />
            </a>
           
            </>       
        ),
    }
    
    ];
            const onChangeSesion= (event,prop) => {
                if(event._isAMomentObject)
                {
                    setParticipacionGrupalPorIngresar({...participacionGrupalPorIngresar,['LSFFechaSesionGTM']:event._d});
                }
                else
                {
                    if(Array.isArray(event)){
                        let valorArreglo=[];
                        for(var i=0;i<event.length;i++){
                            valorArreglo.push(event[i].value)
                        }
                        const propiedad=prop.name?.replace('Name','')
                        setParticipacionGrupalPorIngresar({...participacionGrupalPorIngresar,[propiedad]:valorArreglo});
                    }
                    else
                    {
                        let valor=event.target.value;
                        const nombre=event.target.name?.replace('Name','')
                        setParticipacionGrupalPorIngresar({...participacionGrupalPorIngresar,[nombre]:valor});
                    }
                }
            }

            const crearParticipacionGrupal = async() => {
                setChange(false);
                const resp=await insertParticipacionGrupal(participacionGrupalPorIngresar);
                if(resp.success)
                {
                    setParticipacionGrupalPorIngresar({'LSFComentarios':''});
                    setChange(true);
                }
            };
            const eliminarParticipacionGrupal= async(id) => {
                setChange(false);
                const resp=await deleteFichaConsultanteParticipacionGrupal(id);
                if(resp.success)
                {
                    setChange(true);
                }
            };
    const onDelete=async n=>{
    
        confirmAlert({
            title: '',
            message: '¿Seguro desea eliminar participación grupal?',
            buttons: [
              {
                label: 'Si',
                onClick: () => {
                    eliminarParticipacionGrupal(n)
                }
              },
              {
                label: 'No'
                
              }
            ]
          });
    
    }
  
    useEffect( () => {
       async function setParticipacionGrupalFuncion(){
        await getParticipacionGrupalPorConsultante();
        await getUsuariosTerapeutasOcupacionales();  
        await getUsuariosPsicologas();  
        await getUsuariosOtros();
        await updateRespuestaIngresoParticipacionGrupal();   

       }
       setParticipacionGrupalFuncion();
        
        
    }, [isChangedElements]);
    
    usuariosTo?.map((elem)=>{
        opcionesSelectorTO.push(
              {
                  value:elem.Usuario,
                  label:elem.NombreSocial 
                }
          )
    });
    usuariosSicologas?.map((elem)=>{
        opcionesSelectorPsicologas.push(
              {
                  value:elem.Usuario,
                  label:elem.NombreSocial 
                }
          )
    });
    usuariosOtros?.map((elem)=>{
        opcionesSelectorOtros.push(
              {
                  value:elem.Usuario,
                  label:elem.NombreSocial 
                }
          )
    });
        return (
            <>
             <Container fluid>
             <Tabs
              defaultActiveKey="1"
              id="uncontrolled-tab-example"
              className="mb-3">   
                <Tab eventKey={1} title={'Listado Participaciones Grupales'}>
                    {/*<Form>*/}
                    <Row>
                    <Col>
                    <div className='table-responsive'>
                    <DataTable
                    columns={columnas}
                    data={participacionGrupalFicha}
                    pagination
                    paginationComponentOptions={paginacionOpciones}
                    fixedHeader
                    fixedHeaderScrollHeight='600px'
                    noDataComponent="No hay elementos para mostrar"
                    striped={true}
                   
                />
                    </div>

                    </Col>
                    </Row>
                {/*</Form>*/}
                </Tab>
                <Tab eventKey={2} title={'Agregar Participación Grupal'}>
                    {/*<Form>*/}
                    <Row>
                    <Col xs="6">
                    <label>Profesionales Psicóloga</label><br></br>
                    <Select
                        placeholder="Seleccione una o más opciones"
                        isMulti
                        name="LSFSicologas"
                        options={opcionesSelectorPsicologas}
                        //value={sesionPorIngresar?.LSFSicologas}
                        value={opcionesSelectorPsicologas.filter(item => participacionGrupalPorIngresar?.LSFSicologas?.includes(item.value))}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={ onChangeSesion}
                        
                        />
                    </Col>
                    <Col xs="6">
                        <label>Profesionales Terapeuta Ocupacional</label>
                        <Select
                        placeholder="Seleccione una o más opciones"
                        isMulti
                        name="LSFTO"
                        options={opcionesSelectorTO}
                        value={opcionesSelectorTO.filter(item => participacionGrupalPorIngresar?.LSFTO?.includes(item.value))}
                        
                        className="basic-multi-select"
                        classNamePrefix="select"
                       
                        onChange={ (e,prop) => { onChangeSesion(e,prop) }}
                        
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs="6">
                    <label>Profesionales Otros</label><br></br>
                    <Select
                        placeholder="Seleccione una o más opciones"
                        isMulti
                        name={'LSFOtros'}
                        options={opcionesSelectorOtros}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={opcionesSelectorOtros.filter(item => participacionGrupalPorIngresar?.LSFOtros?.includes(item.value))}
                        onChange={ (e,prop) => { onChangeSesion(e,prop) }}
                        
                        />
                    </Col>
                    <Col xs="6">
                        <label>Fecha Sesión (Hora Santiago,Chile)</label>
                        <Datetime
                            onChange={onChangeSesion}
                            name={'LSFFechaSesionGTM'}
                            value={participacionGrupalPorIngresar?.LSFFechaSesionGTM}
                            utc={true}
                            
                        ></Datetime>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                 
                    <label>Comentarios</label>
                    <Form.Control
                        name="LSFComentarios"
                        value={participacionGrupalPorIngresar?.LSFComentarios}
                        placeholder=""
                        type="textarea"
                        as="textarea"
                        onChange={onChangeSesion}
                        rows={12}>
                    </Form.Control>
                   
                    </Col>
                   
                </Row>
                <MensajeAlerta mensajeTexto={respuestaIngresoParticipacionGrupal.mensajeTexto} estado={respuestaIngresoParticipacionGrupal.estado} />
                <Row>
                    <Col xs="6">
                    </Col>
                    <Col xs="6">
                 
                    <Button
                        className="btn-fill pull-right"
                        type="submit"
                        variant="info"
                        onClick={(e)=>{
                            e.preventDefault();
                            crearParticipacionGrupal();
                     
                        }}
                      >
                    Ingresar Sesión
                  </Button>
                   
                    </Col>
                   
                </Row>

               
                </Tab>
            </Tabs>
            </Container>
            </>
        )
}
export default ListadoParticipacionesGrupalesFicha;